import { logoTone, opaqueShare } from "./studio.ts";

// Reads a logo shown on the page (a same-origin blob: URL) through a small canvas: its tone, for the same-tone
// warning, and its opaque share, since one-color ink needs a see-through area. Null when it cannot be read.
export async function measureLogoPixels(url: string): Promise<{ tone: "light" | "dark" | null; share: number } | null> {
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    const scale = Math.min(1, 256 / Math.max(img.naturalWidth, img.naturalHeight, 1));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    return { tone: logoTone(data), share: opaqueShare(data) };
  } catch {
    return null;
  }
}
